function mdTogglePanel() {
  var $ = window.jQuery || window.$;
  if (!$) return;

  var $content = $('#mdPanelContent');
  var $icon = $('#mdToggleIcon');

  if ($content.is(':visible')) {
    $content.slideUp(200);
    $icon.removeClass('md-open');
  } else {
    $content.slideDown(200);
    $icon.addClass('md-open');
  }
}

var mdCurrentPopupData = null;

function mdOpenVariantPopup(productData) {
  mdCurrentPopupData = productData;
  var $ = window.jQuery || window.$;
  
  $('#mdPopupProductImage').attr('src', productData.image);
  $('#mdPopupProductName').text(productData.title);
  $('#mdPopupProductPrice').text(formatMoney(productData.price));
  
  var variantsList = $('#mdVariantsList');
  variantsList.empty();
  
  var selectedVariantId = null;
  
  productData.variants.forEach(function(variant) {
    var isAvailable = variant.available;
    var hasEnoughInventory = true;
    
    if (isAvailable) {
      var inventory = variant.inventory_quantity != null ? variant.inventory_quantity : 999;
      hasEnoughInventory = inventory >= productData.requiredQuantity;
    }
    
    var isSelectable = isAvailable && hasEnoughInventory;
    
    var variantHtml = '<div class="md-variant-option' + 
      (isSelectable ? '' : ' md-variant-disabled') + 
      '" data-variant-id="' + variant.id + 
      '" data-variant-price="' + variant.price + 
      '" data-variant-image="' + (variant.featured_image ? variant.featured_image.src : productData.image) + 
      '" data-variant-title="' + variant.title + 
      '" data-selectable="' + isSelectable + '">' +
      '<div class="md-variant-radio"></div>' +
      '<div class="md-variant-info">' +
      '<p class="md-variant-name">' + variant.title + '</p>';
    
    if (!isSelectable) {
      if (!isAvailable) {
        variantHtml += '<p class="md-variant-unavailable">Out of Stock</p>';
      } else if (!hasEnoughInventory) {
        variantHtml += '<p class="md-variant-unavailable">Not enough inventory</p>';
      }
    } else {
      variantHtml += '<p class="md-variant-price">' + formatMoney(variant.price) + '</p>';
    }
    
    variantHtml += '</div></div>';
    
    variantsList.append(variantHtml);
  });
  
  $('#mdVariantPopup').addClass('md-show');
  $('#mdSelectVariantBtn').prop('disabled', true);
}

function mdCloseVariantPopup() {
  $('#mdVariantPopup').removeClass('md-show');
  mdCurrentPopupData = null;
}

jQuery(function($) {
  var $panel = $('#md-bundle-panel');
  var $tabs = $panel.find('.md-tab-swatch');
  var $grid = $panel.find('.md-color-grid');
  var $totalPriceEl = $('product-price .price');

  var formId = $panel.find('.child_variant_id').first().attr('form');
  var $productForm = formId ? $('#' + formId) : $panel.closest('form');
  var $addToCartBtn = $();

  if ($productForm && $productForm.length) {
    $addToCartBtn = $productForm.find(
      'button[type="submit"], input[type="submit"], .product-form__submit'
    ).first();
  }

  function getNextEmptyTab() {
    return $tabs.filter('.color-tab--empty').first();
  }

  function setActiveTab($tab) {
    $tabs.removeClass('md-active');
    $tab.addClass('md-active');
    updateSwatchesAvailablity();
  }

  function allTabsFilled() {
    return $tabs.filter('.color-tab--empty').length === 0;
  }

  function areAllSlotsFilled() {
    return allTabsFilled();
  }

  window.formatMoney = function(amount) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount);
    }
    return (amount / 100).toFixed(2);
  }

  function updateBundleTotal() {
    var basePrice = 0;

    if (window.selected_variant && window.selected_variant.price) {
      basePrice = parseInt(window.selected_variant.price, 10) || 0;
    }

    var addOnTotal = 0;

    $panel.find('.child_variant_id').each(function() {
      var vId = $(this).val();
      if (vId) {
        var p = parseInt($(this).attr('price'), 10);
        if (!isNaN(p)) {
          addOnTotal += p;
        }
      }
    });
    var discount = 10;
    discount = (100 - discount)/100;
    var total = (basePrice + addOnTotal) * discount;
    $totalPriceEl.text(formatMoney(total));
  }

  function checkGridVisibility() {
    if (allTabsFilled()) {
      $grid.stop(true, true).slideUp();
    }
  }

  function updateAddToCartState() {
    if (!$addToCartBtn.length) return;

    if (areAllSlotsFilled()) {
      $addToCartBtn
        .removeClass('md-atc-disabled')
        .prop('disabled', false)
        .removeAttr('title');
    } else {
      $addToCartBtn
        .addClass('md-atc-disabled')
        .prop('disabled', true)
        .attr('title', 'PLEASE SELECT ABOVE OPTION ALL');
    }
  }

  function selectProductVariant(variantId, variantPrice, variantImage, variantTitle) {
    var $activeTab = $tabs.filter('.md-active').first();
    if (!$activeTab.length) {
      $activeTab = $tabs.first();
      setActiveTab($activeTab);
    }
    var $tabWrapper = $activeTab.closest('.md-color-tab');
    var $inner = $activeTab.find('.md-swatch-inner');

    $activeTab.removeClass('color-tab--empty');
    $inner
      .addClass('md-filled')
      .css({
        'background-image': 'url(' + variantImage + ')',
        'background-size': 'cover',
        'background-position': 'center',
        'border': 'none'
      });

    var $childInput = $tabWrapper.find('.child_variant_id');
    $childInput
      .val(variantId)
      .attr('price', variantPrice);
    
    var $label = $tabWrapper.find('.md-tab-label');
    $label
      .text(variantTitle)
      .addClass('md-selected-label');

    var $nextEmpty = getNextEmptyTab();
    if ($nextEmpty.length) {
      setActiveTab($nextEmpty);
    } else {
      setActiveTab($activeTab);
    }

    updateBundleTotal();
    checkGridVisibility();
    updateAddToCartState();
  }

  $grid.on('click', '.md-color-option', function() {
    var $colorOption = $(this);
    var $swatch = $colorOption.find('.md-color-swatch');

    if ($swatch.hasClass('md-disabled')) {
      return;
    }

    var title  = $swatch.attr('title') || $colorOption.find('.md-color-name').text().trim();
    var variant = $swatch.attr('variant');
    var inventory = Number($swatch.attr('inventory'));
    var image   = $swatch.attr('image');
    var price   = parseInt($swatch.attr('price'), 10) || 0;
    var variantsJson = $swatch.attr('variants');
    
    var variants = [];
    try {
      variants = JSON.parse(variantsJson);
    } catch(e) {
      variants = [];
    }

    var $activeTab = $tabs.filter('.md-active').first();
    if (!$activeTab.length) {
      $activeTab = $tabs.first();
      setActiveTab($activeTab);
    }
    var $tabWrapper = $activeTab.closest('.md-color-tab');
    var color_quantity = Number($tabWrapper.find('.child_variant_quantity').val());

    if (variants.length > 1) {
      mdOpenVariantPopup({
        title: title,
        price: price,
        image: image,
        variants: variants,
        requiredQuantity: color_quantity
      });
    } else {
      if(inventory < color_quantity){
        alert('Required inventory is less');
        return;
      }
      selectProductVariant(variant, price, image, title);
    }
  });

  $(document).on('click', '.md-variant-option', function() {
    var $option = $(this);
    
    if ($option.hasClass('md-variant-disabled')) {
      return;
    }
    
    $('.md-variant-option').removeClass('md-variant-selected');
    $option.addClass('md-variant-selected');
    
    $('#mdSelectVariantBtn').prop('disabled', false);
  });

  $(document).on('click', '#mdSelectVariantBtn', function() {
    var $selected = $('.md-variant-option.md-variant-selected');
    
    if ($selected.length) {
      var variantId = $selected.attr('data-variant-id');
      var variantPrice = $selected.attr('data-variant-price');
      var variantImage = $selected.attr('data-variant-image');
      var variantTitle = $selected.attr('data-variant-title');
      
      selectProductVariant(variantId, variantPrice, variantImage, variantTitle);
      mdCloseVariantPopup();
    }
  });

  $(document).on('click', '.md-variant-popup', function(e) {
    if ($(e.target).hasClass('md-variant-popup')) {
      mdCloseVariantPopup();
    }
  });

  $panel.on('click', '.md-tab-swatch', function() {
    var $tab = $(this);
    setActiveTab($tab);
    $grid.stop(true, true).slideDown();
  });

  $panel.on('click', '.md-clear-all', function(e) {
    e.preventDefault();

    $tabs.each(function() {
      var $tab = $(this);
      var $wrap = $tab.closest('.md-color-tab');
      var $inner = $tab.find('.md-swatch-inner');

      $tab
        .addClass('color-tab--empty')
        .removeClass('md-active');

      $inner
        .removeClass('md-filled')
        .removeAttr('style');

      var $childInput = $wrap.find('.child_variant_id');
      $childInput
        .val('')
        .data('price', null);

      var $label = $wrap.find('.md-tab-label');
      var defaultTitle = $label.data('title') || 'Add product';
      $label
        .text(defaultTitle)
        .removeClass('md-selected-label');
    });

    setActiveTab($tabs.first());
    $grid.stop(true, true).slideDown();
    updateBundleTotal();
    updateAddToCartState();
  });

  if ($productForm && $productForm.length) {
    $productForm.on('submit.mdBundleFix', function(e) {
      if (!areAllSlotsFilled()) {
        e.preventDefault();
        alert('PLEASE SELECT ABOVE OPTION ALL');
        updateAddToCartState();
        return false;
      }

      var currentParentId = $(this).find('input[name="id"]').val();
      if (currentParentId) {
        $('.parent_variant_id').val(currentParentId);
      }
    });

    $addToCartBtn.on('click.mdBundle', function(e) {
      if ($(this).prop('disabled')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('PLEASE SELECT ABOVE OPTION ALL');
        return false;
      }
    });

    $addToCartBtn.on('mouseenter', function() {
      if (!areAllSlotsFilled()) {
        $(this).attr('title', 'PLEASE SELECT ABOVE OPTION ALL');
      }
    });
  }

  $(document).on('mdvariant:change', function(e) {
    if (e.detail.variant) {
      window.selected_variant = e.detail.variant;
      $('.parent_variant_id').val(e.detail.variant.id);
      window.selected_color_quantity = window.color_quantity[window.selected_variant.id];
      $('.child_variant_quantity').each(function(index, item){
        var quantity = window.selected_color_quantity[index];
        quantity = quantity == 0 ? 1: quantity;
        $(this).val(quantity)
      });
      updateBundleTotal();
    }
  });

  function updateSwatchesAvailablity(){
    const inventory_required = Number($('.md-tab-swatch.md-active').parents('.md-color-tab').find('.child_variant_quantity').val());
    $('.md-color-option').each(function(){
      const inventory = Number($(this).find('.md-color-swatch').attr('inventory'));
      if(inventory < inventory_required){
        $(this).find('.md-color-swatch').addClass('md-disabled').find('.md-out-of-stock').show();
      }else{
        $(this).find('.md-color-swatch').removeClass('md-disabled').find('.md-out-of-stock').hide();
      }
    })
  }

  updateBundleTotal();
  updateAddToCartState();
  updateSwatchesAvailablity();
});